import React from "react";
import { Culture } from "../../../types/culture";
import { translateString } from "../../../translations/gridTranslationHelper";

export default function BsModal2DefaultButtons({ closeFunction, culture, okFunc }: { closeFunction: () => void; culture: Culture; okFunc?: () => boolean }) {
    const renderOkButton = okFunc && (
        <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
                const result = okFunc();
                if (result) closeFunction();
            }}
        >
            {translateString("inBoundBtnOk", culture)}
        </button>
    );

    return (
        <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={closeFunction}>
                {translateString("close", culture)}
            </button>
            {renderOkButton}
        </div>
    );
}
